import { useLayoutEffect } from 'react'

import {
  applyArenaDynamicHead,
  arenaLanguageTag,
  arenaSeoRobots,
} from '@/lib/arena-dynamic-seo'
import { useI18n } from '@/lib/i18n'

export function useGameSeo(enabled = true) {
  const { language } = useI18n()

  useLayoutEffect(() => {
    if (!enabled)
      return
    return applyArenaDynamicHead({
      title: 'Werewolf game | Mentiss',
      description: 'Play and review a Mentiss Werewolf game.',
      language: arenaLanguageTag(language),
      robots: arenaSeoRobots(false),
    })
  }, [enabled, language])
}
